import { memo } from 'react';

import { DefaultBanner } from './components/default-banner';
import { PromoBanner } from './components/promo-banner';
import { DiscountBanner, DiscountVariant } from './components/discount-banner';
import { getDiscountTimer } from 'src/stores/legend';

export enum BannerType {
  DEFAULT,
  PURPLE,
  RED,
  PROMO,
}

type Props = {
  onClick?: () => void;
  variant?: BannerType;
  onFinish?: () => void;
  isNgrow?: boolean;
  className?: string;
  targetTime?: number;
};

export const TARGET_TIME = getDiscountTimer();

const BANNER_CONFIG = {
  [BannerType.PROMO]: ({
    targetTime = getDiscountTimer(),
    ...props
  }: Props) => <PromoBanner {...props} targetTime={targetTime} />,
  [BannerType.DEFAULT]: ({
    targetTime = getDiscountTimer(),
    ...props
  }: Props) => <DefaultBanner {...props} targetTime={targetTime} />,
  [BannerType.RED]: ({ targetTime = getDiscountTimer(), ...props }: Props) => (
    <DiscountBanner
      {...props}
      variant={DiscountVariant.RED}
      targetTime={targetTime}
    />
  ),
  [BannerType.PURPLE]: ({
    targetTime = getDiscountTimer(),
    ...props
  }: Props) => (
    <DiscountBanner
      {...props}
      variant={DiscountVariant.PURPLE}
      targetTime={targetTime}
    />
  ),
} as const;

export const SimpleBanner = memo(
  ({
    onClick,
    variant = BannerType.DEFAULT,
    onFinish,
    className,
    targetTime = getDiscountTimer(),
  }: Props) => {
    const renderBanner = BANNER_CONFIG[variant];
    return renderBanner({
      onClick,
      variant,
      onFinish,
      className,
      targetTime,
    });
  },
);

SimpleBanner.displayName = 'SimpleBanner';
